import type { SubComponentsReturnType } from '../../types';

import { Body } from './Body';
import { Footer } from './Footer';
import { Header } from './Header';
import type { InstagramStoryComponentsProps } from './types';

export function useInstagramStoryComponents(props: InstagramStoryComponentsProps): SubComponentsReturnType {
	return {
		header: <Header {...props} />,
		body: <Body {...props} />,
		footer: <Footer {...props} />,
	};
}
